import { render, staticRenderFns } from "./SettingUseChat.vue?vue&type=template&id=2add9940"
import script from "./SettingUseChat.vue?vue&type=script&lang=js"
export * from "./SettingUseChat.vue?vue&type=script&lang=js"
import style0 from "./SettingUseChat.vue?vue&type=style&index=0&id=2add9940&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports